import { Reducer } from 'redux';
import { flow, set } from 'lodash/fp';

import { ChatbotActionTypes, ChatbotState } from './types';
import { LoginActionTypes } from '../../../auth/login/store/types';
import { MLPageData } from '../../../datasets/store/mlTypes';
import { PdfSearchResults } from '../../document-viewer/store/types';

export const initialAIAnswer: MLPageData = { value: '', page: undefined, snippet: '', highlightIndexes: [], isFuzzyMatchHighlight: false };
export const initialAIResults: PdfSearchResults = { page: 0, indexes: [] };

export const INITIAL_STATE: ChatbotState = {
    chatbotModalOpen: false,
    chatbotLoading: false,
    aiAnswer: initialAIAnswer,
    aiResults: initialAIResults
};

export const chatbotReducer: Reducer<ChatbotState> = (state = INITIAL_STATE, { payload, type }): ChatbotState => {
    switch (type) {
        case ChatbotActionTypes.TOGGLE_CHATBOT_MODAL:
            return set('chatbotModalOpen', payload, state);
        case ChatbotActionTypes.ASK_CHATBOT_STARTED:
            return set('chatbotLoading', true, state);
        case ChatbotActionTypes.ASK_CHATBOT_SUCCESSFUL:
            return flow(
                set('chatbotLoading', false),
                set('aiAnswer', payload)
            )(state);
        case ChatbotActionTypes.ASK_CHATBOT_FAILED:
            return flow(
                set('chatbotLoading', false),
                set('aiAnswer', { value: payload, page: undefined, snippet: '' })
            )(state);
        case ChatbotActionTypes.RESET_CHATBOT_MODAL:
            return flow(
                set('chatbotLoading', false),
                set('aiAnswer', initialAIAnswer),
                set('aiResults', initialAIResults)
            )(state);
        case ChatbotActionTypes.SET_AI_SORTED_RESULTS:
            return set('aiResults', payload, state);
        case ChatbotActionTypes.RESET_CHATBOT_RESULTS:
            return flow(
                set('aiAnswer', initialAIAnswer),
                set('aiResults', initialAIResults)
            )(state);
        case LoginActionTypes.LOGOUT_SUCCESSFUL:
            return INITIAL_STATE;
        default:
            return state;
    }
};
